import React from 'react';
import { Link } from 'react-router-dom';
import ResonanceOrb from './ResonanceOrb';

/**
 * Renders the final download and legal-navigation chapter. Accepts no props.
 *
 * @returns {React.ReactElement} Chapter eight containing honest unavailable-
 *   platform controls and exact legal/support routes.
 * @sideEffects Has no external side effects beyond React and Router rendering.
 */
export default function DownloadFinale({ index = 10 }) {
  const handleSocialClick = (e, appUrl, webUrl) => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      e.preventDefault();
      const start = Date.now();
      window.location.href = appUrl;
      setTimeout(() => {
        if (!document.hidden && Date.now() - start < 1500) {
          window.open(webUrl, '_blank');
        }
      }, 1000);
    }
  };

  return (
    <section
      className="download-finale"
      data-chapter-index={index}
      id="finale"
      aria-labelledby="finale-title"
    >
      <footer className="download-finale__footer">
        <div className="download-finale__brand">
          <h2 id="finale-title">For intentional relationships.</h2>
          <ResonanceOrb size={280} />
          <div className="download-finale__controls">
            <Link to="/download" className="download-btn download-btn--active" style={{ textDecoration: 'none' }}>
              <svg viewBox="0 0 24 24" className="download-btn__icon">
                <g fill="currentColor">
                  <path d="M18.546,12.763c0.024-1.87,1.004-3.597,2.597-4.576c-1.009-1.442-2.64-2.323-4.399-2.378    c-1.851-0.194-3.645,1.107-4.588,1.107c-0.961,0-2.413-1.088-3.977-1.056C6.122,5.927,4.25,7.068,3.249,8.867    c-2.131,3.69-0.542,9.114,1.5,12.097c1.022,1.461,2.215,3.092,3.778,3.035c1.529-0.063,2.1-0.975,3.945-0.975    c1.828,0,2.364,0.975,3.958,0.938c1.64-0.027,2.674-1.467,3.66-2.942c0.734-1.041,1.299-2.191,1.673-3.408    C19.815,16.788,18.548,14.879,18.546,12.763z" />
                  <path d="M15.535,3.847C16.429,2.773,16.87,1.393,16.763,0c-1.366,0.144-2.629,0.797-3.535,1.829    c-0.895,1.019-1.349,2.351-1.261,3.705C13.352,5.548,14.667,4.926,15.535,3.847z" />
                </g>
              </svg>
              <div className="download-btn__text">
                <span className="download-btn__label">iOS App</span>
                <span className="download-btn__status">Try Beta</span>
              </div>
            </Link>
            <Link to="/download" className="download-btn download-btn--active" style={{ textDecoration: 'none' }}>
              <svg viewBox="0 0 24 24" className="download-btn__icon">
                <path fill="currentColor" d="m21.762,9.942L4.67.378c-.721-.466-1.635-.504-2.393-.099-.768.411-1.246,1.208-1.246,2.08v19.282c0,.872.477,1.668,1.246,2.079.755.404,1.668.37,2.393-.098l17.092-9.564c.756-.423,1.207-1.192,1.207-2.058s-.451-1.635-1.207-2.058Zm-5.746-1.413l-2.36,2.36L5.302,2.534l10.714,5.995ZM2.604,21.906V2.094l9.941,9.906L2.604,21.906Zm2.698-.439l8.355-8.355,2.36,2.36-10.714,5.995Zm15.692-8.78l-3.552,1.987-2.674-2.674,2.674-2.674,3.552,1.987c.363.203.402.548.402.686s-.039.483-.402.686Z" />
              </svg>
              <div className="download-btn__text">
                <span className="download-btn__label">Android App</span>
                <span className="download-btn__status">Try Beta</span>
              </div>
            </Link>
          </div>
        </div>
        <div className="download-finale__meta">
          <div className="download-finale__socials">
            <a
              href="https://instagram.com/realonmilan"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) =>
                handleSocialClick(
                  e,
                  'instagram://user?username=realonmilan',
                  'https://instagram.com/realonmilan',
                )
              }
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" className="social-icon">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" fill="currentColor"/>
              </svg>
            </a>
            <a
              href="https://facebook.com/realonmilan"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) =>
                handleSocialClick(
                  e,
                  'fb://facewebmodal/f?href=https://www.facebook.com/realonmilan',
                  'https://facebook.com/realonmilan',
                )
              }
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" className="social-icon">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z" fill="currentColor"/>
              </svg>
            </a>
          </div>
          <nav className="download-finale__legal" aria-label="Legal and support">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/tnc">Terms</Link>
            <Link to="/support">Support</Link>
          </nav>
        </div>
      </footer>
    </section>
  );
}
